import { FunctionField } from 'react-admin';
import Button from '@mui/material/Button';
import { SetCurrentButtonProps } from './types';
import useController from './useController';

const SetCurrentButton = ({ source }: SetCurrentButtonProps) => {
  const { canSetCurrentAddress, setCurrentAddress } = useController();

  return (
    <FunctionField
      source={source}
      sortable={false}
      render={() => {
        return canSetCurrentAddress ? <Button onClick={setCurrentAddress}>Set as current</Button> : null;
      }}
    />
  );
};

export default SetCurrentButton;
